import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './app-component/App';
import * as serviceWorker from './serviceWorker';

import firebase from 'firebase/app';

firebase.initializeApp({
  apiKey: "AIzaSyAP3MlkVYmmjlqHHAcjGok0jLDq84ZvCx0",
  authDomain: "tb-icannotsleep.firebaseapp.com",
  databaseURL: "https://tb-icannotsleep.firebaseio.com",
  projectId: "tb-icannotsleep"
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
